<template>
    <HomeLayout :isShowDelivery="true" customClass="">
        <div class="relative max-full-hd">
            <DashboardHome
                    v-if="dashboardHomeConfig != null"
                    :apiConfig="dashboardHomeConfig"
            ></DashboardHome>
        </div>
        <div class="mt-11">
            <CategoryHome
                    v-if="cateHomeConfig != null"
                    ref="cate-home"
                    :apiConfig="cateHomeConfig"
            ></CategoryHome>
        </div>
        <DownloadApp></DownloadApp>
    </HomeLayout>
</template>
<script>
import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
//component
import HomeLayout from '@/components/Layout/Page/HomeLayout.vue';
import DashboardHome from '../component/DashboardHome/DashboardHome.vue';
import CategoryHome from '../component/CategoryHome/CategoryHome.vue';
import DownloadApp from '../component/DownloadApp.vue';
//service
import HomeApi from '../service/HomeApi.js';

//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import DeliveryMixin from '@/mixin/DeliveryMixin';
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    mixins: [AuthStatusMixin, DeliveryMixin, ModalMixin, LocaleMixin],
    inject: ["HomeStore"],
    components: {
        HomeLayout,
        DashboardHome,
        CategoryHome,
        DownloadApp,
    },
    data: function () {
        return {
            dashboardHomeConfig: null,
            cateHomeConfig: null,
        };
    },
    created() {
        this.tracking.screenName('homepage');
        this.tracking.event('homepage','view_home_page', null, null);
    },
    mounted: function () {
        Util.scrollTop();
        this.setScrollLoadMore();
        this.getPopupCat();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        //AuthStatusMixin
        onAccountInit: function() {
            this.deliveryInit();
        },
        //DeliveryMixin
        onDeliveryUpdate: function () {
            let tier = this.tier;
            console.log('tier', tier);

            let dashboardHomeConfig = ConfigManager.getDashboardHome(tier);
            // console.log('config dashboard', dashboardHomeConfig);
            this.dashboardHomeConfig = dashboardHomeConfig;

            let cateHomeConfig = ConfigManager.getCategoryHome(tier);
            // console.log('config category', cateHomeConfig);
            this.cateHomeConfig = cateHomeConfig;
        },

        setScrollLoadMore: function () {
            setTimeout(() => {
                Util.scrollTop();
            }, 100);

            setTimeout(() => {
                window.onscroll = () => {
                    // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                    var scrollOffSet = 100;
                    var pageHeight = Math.max(
                        window.pageYOffset,
                        document.documentElement.scrollTop,
                        document.body.scrollTop
                    );
                    var bottomOfWindow =
                        pageHeight + window.innerHeight >
                        document.documentElement.offsetHeight - scrollOffSet;
                    if (bottomOfWindow) {
                        this.loadMore();
                    }
                };
            }, 500);
        },

        loadMore: function() {
            this.$refs['cate-home'].loadMore();
        },
        getPopupCat: async function() {
            this.HomeStore.methods.init();
            this.HomeStore.methods.initStatus().subscribe(() => {
                this.checkShowPopup();
            });
        },
        checkShowPopup: function() {
            let catIdParams = this.$route.params.catId;
            for (let item of this.HomeStore.state.categoryPopup) {
                if (catIdParams == item.id) {
                    let msg = this.localeCode == 1033 ? item[1033] : item[1054];
                    this.modal.errorModal
                        .clearModal()
                        .setMsg(msg)
                        .show();
                }
            }
        },
        apiPopupCat: function() {
            return new Promise((resolve) => {
                HomeApi.apiPopupCat().subscribe({
                    next: (data) => {
                        console.log(data);
                        if (data.categoryPopup) {
                            this.categoryPopup = data.categoryPopup;
                        }

                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/display.scss';
</style>
